// GENERADO por tooling/gen-routes.mjs — no editar a mano.
// Reejecutar tras agregar, mover o borrar una página:
//   node tooling/gen-routes.mjs src
//
// Sale de src/app/**, igual que el enrutado por archivos que traía Next: los
// segmentos [id] pasan a :id, las carpetas (entre paréntesis) agrupan sin salir
// en la URL, y un layout.tsx envuelve a todo su subárbol. Se carga con lazy()
// para conservar el code-splitting por ruta que Next hacía solo.
import { lazy } from "react";
import type { ComponentType, ReactNode } from "react";

export interface RutaHoja {
  path: string;
  Component: ComponentType;
}

export interface BloqueConLayout {
  Layout: ComponentType<{ children: ReactNode }>;
  hijas: NodoRuta[];
}

export type NodoRuta = RutaHoja | BloqueConLayout;

export const esBloque = (n: NodoRuta): n is BloqueConLayout => "Layout" in n;

export const routes: NodoRuta[] = [
  { path: "/", Component: lazy(() => import("./app/page")) },
  {
    Layout: lazy(() => import("./app/(panel)/layout")),
    hijas: [
      { path: "/avisos", Component: lazy(() => import("./app/(panel)/avisos/page")) },
      { path: "/campanas", Component: lazy(() => import("./app/(panel)/campanas/page")) },
      { path: "/categorias", Component: lazy(() => import("./app/(panel)/categorias/page")) },
      { path: "/clientes", Component: lazy(() => import("./app/(panel)/clientes/page")) },
      { path: "/clientes/:id", Component: lazy(() => import("./app/(panel)/clientes/[id]/page")) },
      { path: "/cobros", Component: lazy(() => import("./app/(panel)/cobros/page")) },
      { path: "/comercios", Component: lazy(() => import("./app/(panel)/comercios/page")) },
      { path: "/comercios/:id", Component: lazy(() => import("./app/(panel)/comercios/[id]/page")) },
      { path: "/comercios/:id/editar", Component: lazy(() => import("./app/(panel)/comercios/[id]/editar/page")) },
      { path: "/comercios/:id/menu", Component: lazy(() => import("./app/(panel)/comercios/[id]/menu/page")) },
      { path: "/comercios/nuevo", Component: lazy(() => import("./app/(panel)/comercios/nuevo/page")) },
      { path: "/comunicados", Component: lazy(() => import("./app/(panel)/comunicados/page")) },
      { path: "/configuracion", Component: lazy(() => import("./app/(panel)/configuracion/page")) },
      { path: "/cupones", Component: lazy(() => import("./app/(panel)/cupones/page")) },
      { path: "/cupos-efectivo", Component: lazy(() => import("./app/(panel)/cupos-efectivo/page")) },
      { path: "/dashboard", Component: lazy(() => import("./app/(panel)/dashboard/page")) },
      { path: "/geografia", Component: lazy(() => import("./app/(panel)/geografia/page")) },
      { path: "/incidencias", Component: lazy(() => import("./app/(panel)/incidencias/page")) },
      { path: "/mapa", Component: lazy(() => import("./app/(panel)/mapa/page")) },
      { path: "/pagos", Component: lazy(() => import("./app/(panel)/pagos/page")) },
      { path: "/pagos/:id", Component: lazy(() => import("./app/(panel)/pagos/[id]/page")) },
      { path: "/pagos/cuentas", Component: lazy(() => import("./app/(panel)/pagos/cuentas/page")) },
      { path: "/patrocinios", Component: lazy(() => import("./app/(panel)/patrocinios/page")) },
      { path: "/pedidos", Component: lazy(() => import("./app/(panel)/pedidos/page")) },
      { path: "/pedidos/:id", Component: lazy(() => import("./app/(panel)/pedidos/[id]/page")) },
      { path: "/posicionamiento", Component: lazy(() => import("./app/(panel)/posicionamiento/page")) },
      { path: "/reclamos", Component: lazy(() => import("./app/(panel)/reclamos/page")) },
      { path: "/rendiciones-efectivo", Component: lazy(() => import("./app/(panel)/rendiciones-efectivo/page")) },
      { path: "/repartidores", Component: lazy(() => import("./app/(panel)/repartidores/page")) },
      { path: "/repartidores/:id", Component: lazy(() => import("./app/(panel)/repartidores/[id]/page")) },
      { path: "/reportes", Component: lazy(() => import("./app/(panel)/reportes/page")) },
      { path: "/reportes/financiero", Component: lazy(() => import("./app/(panel)/reportes/financiero/page")) },
      { path: "/reportes/repartidores", Component: lazy(() => import("./app/(panel)/reportes/repartidores/page")) },
      { path: "/retiros", Component: lazy(() => import("./app/(panel)/retiros/page")) },
      { path: "/sami-puntos", Component: lazy(() => import("./app/(panel)/sami-puntos/page")) },
      { path: "/suscripciones", Component: lazy(() => import("./app/(panel)/suscripciones/page")) },
      { path: "/tarifas", Component: lazy(() => import("./app/(panel)/tarifas/page")) },
      { path: "/turnos", Component: lazy(() => import("./app/(panel)/turnos/page")) },
      { path: "/turnos/faltas", Component: lazy(() => import("./app/(panel)/turnos/faltas/page")) },
      { path: "/usuarios", Component: lazy(() => import("./app/(panel)/usuarios/page")) },
    ],
  },
  { path: "/login", Component: lazy(() => import("./app/login/page")) },
];
